module.exports = __webpack_public_path__ + "media/images/samples/300x300/14-92ffc50626199f140fa887fcbffd565a.jpg";